import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconAssetCollectionStyle0 = gravityIconIndividualCss;

const GravityIconAssetCollection = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '973425e533ef9c1417412dd14fc1bb915f8aefca', color: this.color, size: this.size }, h("svg", { key: '41bdf3a291ab0d020129106c96a3e42b0b77ace6', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'e81de6318050e02c8292ea4a3c9790bf44c14c81', d: "M6.42 2a.5.5 0 0 0-.5.5V3a.5.5 0 0 0 .5.5h9.08A.5.5 0 0 0 16 3v-.5a.5.5 0 0 0-.5-.5H6.42ZM4.51 5.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5h-13Z", fill: "currentColor" }), h("path", { key: '7390c632928421c36e4895ec672af2dafd784231', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.5 9a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5h-17Zm16 9.5v-8h-15v8h15Z", fill: "currentColor" }))));
    }
};
GravityIconAssetCollection.style = GravityIconAssetCollectionStyle0;

export { GravityIconAssetCollection as gravity_icon_asset_collection };

//# sourceMappingURL=gravity-icon-asset-collection.entry.js.map